import React from 'react'
import instagram from '../images/instagram-icon-min.png'
import facebook from '../images/facebook-icon-min.png'
import twitter from '../images/twitter-icon-min.png'
import whats_app from '../images/whatsapp-icon-min.png'
import '../css/Social-media.css'
import '../css/Common-style.css'

const SocialMedia = () => {
    return (
        <section class="social-media" id="Contact">
            <div class="container text-center">
                <h1>FIND ME ON SOCIAL MEDIA</h1>
                <div class="social-icons">
                <a href="https://www.instagram.com/g_i_r_i_dhar/" target="_blank" rel="noopener noreferrer"><img src={instagram} alt="Instagram icon"/></a>
                <a href="https://www.facebook.com/giridhar.holla.1/" target="_blank"  rel="noopener noreferrer"><img src={facebook} alt="Facebook icon"/></a>
                <a href="https://twitter.com/GiridharaHolla" target="_blank"  rel="noopener noreferrer"><img src={twitter} alt="Twitter icon"/></a>
                <a href="https://wa.me/+919741528701" target="_blank"  rel="noopener noreferrer"><img src={whats_app} alt="Whats app icon"/></a>
                </div>
            </div>
        </section>
    )
}

export default SocialMedia;

